import React, { useEffect, useState, useContext } from 'react'
import { AuthContext } from '../AuthContext'
import {
  OverlayTrigger,
  Tooltip,
  Row,
  Col,
  Form,
  Button,
  Tabs,
  Tab,
  Modal,
} from 'react-bootstrap'
import LockContentComponent from './LockContentComponent'
import axios from 'axios'
import * as dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Legend,
} from 'chart.js'
import { Line } from 'react-chartjs-2'
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Legend
)

dayjs.extend(customParseFormat)
dayjs.extend(isSameOrAfter)

const TrendTracking = ({ title, currentCompanyId }) => {
  const { currentUser, BaseUrl, setIsLoading, brandArr } =
    useContext(AuthContext)

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" className="text-start" {...props}>
      將戰力掃描的資料以每日一點的方式呈現，幫助您了解指標的趨勢變化。
    </Tooltip>
  )
  const relativeTime = require('dayjs/plugin/relativeTime')
  dayjs.extend(relativeTime)
  // +1 天 呈現上才不奇怪
  const today = dayjs().format('YYYY-MM-DD')
  // const postToday = dayjs().add(1, 'day').format('YYYY-MM-DD')
  const oneWeekBefore = dayjs().subtract(7, 'day').format('YYYY-MM-DD')

  //   若時間已超過17:00 預設為今天
  // 若不是則預設昨天
  const getDefaultDate = () => {
    const now = dayjs()
    const cutoffTime = now
      .set('hour', 17)
      .set('minute', 0)
      .set('second', 0)
      .set('millisecond', 0)
    return now.isAfter(cutoffTime)
      ? now.format('YYYY-MM-DD')
      : now.subtract(1, 'day').format('YYYY-MM-DD')
  }

  // TODO: 改回來
  const [startDate, setStartDate] = useState(oneWeekBefore)
  const [endDate, setEndDate] = useState(getDefaultDate())
  const [summaryRecordData, setSummaryRecordData] = useState([
    {
      sumfoc_val_ig: 0,
      avefoc_val_ig: 0,
      sumfoc_val_yt: 0,
      sumfoc_val_fb: 0,
      emofoc_val_fb: 0,
      update_time: '2022-05-01 06:00:00.0',
      emofoc_val_yt: 0,
      newatt_val_yt: 0,
      fanres_val_yt: 0,
      avefoc_val_fb: 0,
      avefoc_val_yt: 0,
      fanres_val_fb: 0,
      fanres_val_ig: 0,
      newatt_val_fb: 0,
      emofoc_val_ig: 0,
      newatt_val_ig: 0,
    },
  ])
  const basicState = {
    fb: [0],
    ig: [0],
    yt: [0],
  }

  const [sumfoc, setSumfoc] = useState({ ...basicState })
  const [avefoc, setAvefoc] = useState({ ...basicState })
  const [emofoc, setEmofoc] = useState({ ...basicState })
  const [newatt, setNewatt] = useState({ ...basicState })
  const [fanres, setFanres] = useState({ ...basicState })
  useEffect(() => {
    const extractData = (key) =>
      summaryRecordData.map((item) => {
        return {
          update_time: dayjs(item['update_time']).format('MM/DD'),
          data: item[key],
        }
      })

    setSumfoc({
      ...sumfoc,
      fb: extractData('sumfoc_val_fb'),
      ig: extractData('sumfoc_val_ig'),
      yt: extractData('sumfoc_val_yt'),
    })

    setAvefoc({
      ...avefoc,
      fb: extractData('avefoc_val_fb'),
      ig: extractData('avefoc_val_ig'),
      yt: extractData('avefoc_val_yt'),
    })

    setEmofoc({
      ...emofoc,
      fb: extractData('emofoc_val_fb'),
      ig: extractData('emofoc_val_ig'),
      yt: extractData('emofoc_val_yt'),
    })

    setNewatt({
      ...newatt,
      fb: extractData('newatt_val_fb'),
      ig: extractData('newatt_val_ig'),
      yt: extractData('newatt_val_yt'),
    })

    setFanres({
      ...fanres,
      fb: extractData('fanres_val_fb'),
      ig: extractData('fanres_val_ig'),
      yt: extractData('fanres_val_yt'),
    })
  }, [summaryRecordData])

  const [days, setDays] = useState(7)

  const getSummaryRecord = 'powerAnalysis/v1/GetSummaryRecord'

  const handleStartDateChange = (event) => {
    setStartDate(event.target.value)
  }
  const handleEndDateChange = (event) => {
    const selectedDate = dayjs(event.target.value, 'YYYY-MM-DD')
    const today = dayjs().startOf('day')
    const cutoffTime = dayjs()
      .set('hour', 17)
      .set('minute', 0)
      .set('second', 0)
      .set('millisecond', 0)

    if (
      selectedDate.isAfter(today) ||
      (selectedDate.isSame(today, 'day') && dayjs().isBefore(cutoffTime))
    ) {
      alert('無法選擇未來日期')
      setEndDate(getDefaultDate())
    } else {
      setEndDate(event.target.value)
    }
  }
  const searchTrend = () => {
    const requestBody =
      currentUser.lv === 2
        ? {
            start_date: startDate,
            end_date: dayjs(endDate).add(1, 'day').format('YYYY-MM-DD'),
            kol_id: currentCompanyId,
          }
        : {
            start_date: startDate,
            end_date: dayjs(endDate).add(1, 'day').format('YYYY-MM-DD'),
          }
    setIsLoading(true)
    if (currentUser.isLocked) {
      return
    }
    axios
      .post(BaseUrl + getSummaryRecord, requestBody, {
        headers: {
          'Content-Type': 'text/plain; charset=UTF-8',
          Accept: '*/*',
          tk: currentUser.tk,
        },
      })
      .then((res) => {
        setIsLoading(false)

        if (res.data.code === '1003') {
          alert('日期格式錯誤')
        } else {
          setSummaryRecordData(res.data.data)
          setDays(dayjs(endDate).add(1, 'day').diff(dayjs(startDate), 'day'))
        }
        console.log('getSummaryRecord', res.data)
      })
      .catch((e) => {
        setIsLoading(false)
        console.log(e)
      })

    if (startDate && endDate && startDate > endDate) {
      alert('結束日期不得小於開始日期')
      return
    }
  }

  useEffect(() => {
    searchTrend()
  }, [currentCompanyId])

  const daysLabel = (days) => {
    const labels = []
    for (let i = days - 1; i >= 0; i--) {
      labels.push(dayjs(endDate).subtract(i, 'day').format('MM/DD'))
    }
    return labels
  }

  const basicOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom',
      },
      title: {
        display: false,
      },
      // tooltip: {
      //   enabled: true,
      //   callbacks: {
      //     label: function (context) {
      //       console.log('context', context)
      //       let label = context.raw + '分'
      //       return label
      //     },
      //   },
      // },
    },

    scales: {
      x: {
        // title: {
        //   display: true,
        //   text: '日期',
        // },
        ticks: {
          autoSkip: true,
          maxTicksLimit: 10,
        },
      },

      y: {
        display: true,
        title: {
          display: true,
          text: '分',
        },
        grid: {
          display: false,
        },
      },
    },
  }
  // const influenceOptions = {
  //   ...basicOptions,
  // }

  const borderWidth = '1.5'
  const pointStyle = true
  const styles = {
    fb: {
      label: 'Facebook',
      data: [],
      borderColor: '#4267B2',
      backgroundColor: '#4267B2',
      borderWidth: borderWidth,
      pointStyle: pointStyle,
    },
    ig: {
      label: 'Instagram',
      data: [],
      borderColor: '#C13584',
      backgroundColor: '#C13584',
      borderWidth: borderWidth,
      pointStyle: pointStyle,
    },
    yt: {
      label: 'YouTube',
      data: [],
      borderColor: '#FF0000',
      backgroundColor: '#FF0000',
      borderWidth: borderWidth,
      pointStyle: pointStyle,
    },
  }

  // 尋找與標籤相匹配的日期的資料項
  const dataMapWithDays = (item, value) =>
    daysLabel(days).map((day) => {
      const foundItem = item[value.brand].find(
        (item) => item.update_time === day
      )
      // 找不到則返回 0
      return foundItem ? foundItem.data : 0
    })

  const influenceData = {
    labels: daysLabel(days),
    datasets: brandArr.map((v) => {
      const style = styles[v.brand]
      return {
        ...style,
        data: dataMapWithDays(sumfoc, v),
      }
    }),
  }

  const topicData = {
    labels: daysLabel(days),
    datasets: brandArr.map((v) => {
      const style = styles[v.brand]
      return {
        ...style,
        data: dataMapWithDays(avefoc, v),
      }
    }),
  }
  const affectionData = {
    labels: daysLabel(days),
    datasets: brandArr.map((v) => {
      const style = styles[v.brand]
      return {
        ...style,
        data: dataMapWithDays(emofoc, v),
      }
    }),
  }
  const newFansData = {
    labels: daysLabel(days),
    datasets: brandArr.map((v) => {
      const style = styles[v.brand]
      return {
        ...style,
        data: dataMapWithDays(newatt, v),
      }
    }),
  }
  const communityData = {
    labels: daysLabel(days),
    datasets: brandArr.map((v) => {
      const style = styles[v.brand]
      return {
        ...style,
        data: dataMapWithDays(fanres, v),
      }
    }),
  }

  const [modalShow, setModalShow] = useState(false)

  const handleClose = () => setModalShow(false)
  const handleShow = () => setModalShow(true)

  const tabArr = [
    {
      id: 'influence',
      title: '影響擴散力',
      data: influenceData,
    },
    {
      id: 'topic',
      title: '話題創造力',
      data: topicData,
    },
    {
      id: 'affection',
      title: '好感渲染力',
      data: affectionData,
    },
    {
      id: 'newFans',
      title: '新粉吸引力',
      data: newFansData,
    },
    {
      id: 'community',
      title: '社群觸及力',
      data: communityData,
    },
  ]

  return (
    <>
      <h4 className="fw-bolder p-3">
        {title}
        <OverlayTrigger
          placement="right"
          delay={{ show: 50, hide: 400 }}
          overlay={renderTooltip}
        >
          <div className="fas fa-question-circle p-1 text-decoration-none"></div>
        </OverlayTrigger>
      </h4>

      <Form>
        <Row className="mb-3">
          <Form.Group as={Row} controlId="formGridEmail">
            <Form.Label column xs="12" md="auto">
              開始日期
            </Form.Label>
            <Col>
              <Form.Control
                type="date"
                value={startDate}
                onChange={handleStartDateChange}
              />
            </Col>
            <Form.Label column xs="12" md="auto">
              結束日期
            </Form.Label>
            <Col>
              <Form.Control
                type="date"
                value={endDate}
                onChange={handleEndDateChange}
              />
            </Col>
            <Col xs="12" md="auto" className="d-flex justify-content-center">
              <Button
                type="button"
                variant="secondary"
                size="md"
                className="item-submit fas fa-search mb-2 mt-3 mt-md-0"
                onClick={searchTrend}
              >
                <Button
                  variant="secondary"
                  as="input"
                  type="button"
                  value="查詢"
                  className="p-0 ps-1"
                  disabled={currentUser.isLocked ? true : false}
                />
              </Button>
            </Col>
          </Form.Group>
        </Row>
      </Form>
      <Tabs
        defaultActiveKey="influence"
        id="justify-tab-example"
        className="mb-3"
        justify
      >
        {tabArr.map((v) => {
          return (
            <Tab key={v.id} eventKey={v.id} title={v.title}>
              {currentUser.isLocked ? (
                <LockContentComponent handleShow={handleShow} />
              ) : (
                <Line options={basicOptions} data={v.data} />
              )}
            </Tab>
          )
        })}
      </Tabs>
      <Modal size="lg" show={modalShow} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>請將您的需求告知我們，我們會盡快替您服務</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          公司：典通股份有限公司
          <br />
          電話：(02)2331-5133#703
          <br />
          客服信箱：
          <a href="mailto:po@dsigroup.com.tw?subject=典通股份有限公司">
            po@dsigroup.com.tw
          </a>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            關閉
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default TrendTracking
